import React from "react";
import './css/style.css';
import axios from 'axios';
import JwModal from './JwModal';
import LoadingSpinner from './LoadingSpinner.jsx';
import config from './config/config.json';

var HostName = config.HostName;
class VendorMgmt extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.changePath = this.changePath.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.resetFields = this.resetFields.bind(this);
        this.handleSharePath = this.handleSharePath.bind(this);
        this.state = {
            isEditable: [],
            isUserLoggedIn: false,
            value: '',
            vendors: [],
            responseString: "",
            loading: false,
            driveFinal: '',
            readOnly: [],
            tempDrive: []
        }
    }
    navigateToLogin(e) {
        e.preventDefault();
        this.props.history.push('/');
    }

    changePath(event) {
        let tempDr = this.state.tempDrive;
        tempDr[event.target.id] = event.target.value;
        this.setState({ tempDrive: tempDr })
    }

    handleChange(event) {
        this.setState({ value: event.target.value, responseString: "" });
    }
    handleSharePath(event) {
        this.setState({ driveFinal: event.target.value });
    }

    componentDidMount() {
        this.setState({ loading: true });
        if (localStorage.getItem("accessToken") !== null && localStorage.getItem("accessToken") !== undefined) {
            this.setState({ isUserLoggedIn: true })
        }
        var url = HostName + "/api/v1/vendors";
        fetch(url, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
        })
            .then(response => {
                if (response.status === 200) {
                    console.log("Fetching vendors successful");
                    return response.json();
                } else if (response.status === 401 || response.status === 403) {
                    console.log("Fetching vendors failed with 4**");
                    this.setState({ isUserLoggedIn: false })
                }
                else if (response.status === 404) {
                    console.log("Fetching vendors failed with 404");
                    return response.json();
                }
            })
            .then(data => {
                this.setState({ vendors: data.data });
                let editable = [];
                let readOnlyArr = [];
                let tempDriveVal = [];
                for (var i = 0; i < this.state.vendors.length; i++) {
                    editable[i] = true;
                    readOnlyArr[i] = 'readOnly';
                    tempDriveVal[i] = this.state.vendors[i].drive;
                }
                this.setState({ tempDrive: tempDriveVal });
                this.setState({ isEditable: editable });
                this.setState({ readOnly: readOnlyArr });
                this.setState({ loading: false })
            }).catch(error => {
                console.log("Fetching vendors failed with an exception");
                this.setState({ vendors: error.data });
                this.setState({ loading: false })
            });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ loading: true });
        var url = HostName + "/api/v1/vendor";
        axios.post(url, {
            "vendorname": this.state.value,
            "drive": this.state.driveFinal
        }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("accessToken")
                }, timeout: config.TimeOut
            }).then(resp => {
                var url = HostName + "/api/v1/vendors";
                fetch(url, {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("accessToken")
                    }
                })
                    .then(response => {
                        if (response.status === 401 || response.status === 403) {
                            console.log("Fetching vendors list failed with 4**");
                            this.setState({ isUserLoggedIn: false })
                        } else {
                            console.log("Fetching vendors list successful");
                            return response.json();
                        }
                    })
                    .then(data => {
                        let tempEditPathArr = this.state.isEditable;
                        let tempReadOnlyArr = this.state.readOnly;
                        let tempTempDriveArr = this.state.tempDrive;
                        tempEditPathArr.push(true);
                        tempReadOnlyArr.push('readOnly');
                        tempTempDriveArr.push(this.state.driveFinal);
                        this.setState({ isEditable: tempEditPathArr, readOnly: tempReadOnlyArr, tempDrive: tempTempDriveArr })
                        this.setState({ vendors: data.data, responseString: resp.data.message, loading: false })
                    })
                    .catch(error => {
                        console.log("Fetching vendors list failed with an exception");
                        this.setState({ responseString: error.response.data.message, loading: false })
                    });
                console.log("Adding vendor successful");
            }).catch(error => {
                console.log("Adding vendor failed with an exception");
                this.setState({ responseString: error.response.data.message, loading: false })
            });
    }
    handleDelete(name, AWS_ACCESS_KEY) {
        this.setState({ loading: true });
        var url = HostName + "/api/v1/vendor";
        axios.delete(url, {
            data: {
                "vendorname": name,
                "accesskey": AWS_ACCESS_KEY
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
            }, timeout: config.TimeOut
        })
            .then(delresp => {
                var url = HostName + "/api/v1/vendors";
                fetch(url, {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("accessToken")
                    }
                })
                    .then(response => {
                        if (response.status === 401 || response.status === 403) {
                            console.log("Fetching vendors list failed with 4**");
                            this.setState({ isUserLoggedIn: false })
                        } else {
                            console.log("Fetching vendors list successful");
                            return response.json();
                        }
                    })
                    .then(data => {
                        var indexPos = 0;
                        for (var i = 0; i < this.state.vendors.length; i++) {
                            if (this.state.vendors[i].name === name) {
                                indexPos = i;
                            }
                        }
                        let tempEditPathArr = this.state.isEditable;
                        let tempReadOnlyArr = this.state.readOnly;
                        let tempTempDriveArr = this.state.tempDrive;
                        tempEditPathArr.splice(indexPos);
                        tempReadOnlyArr.splice(indexPos);
                        tempTempDriveArr.splice(indexPos);
                        this.setState({ isEditable: tempEditPathArr, readOnly: tempReadOnlyArr, tempDrive: tempTempDriveArr })
                        this.setState({ vendors: data.data, responseString: delresp.data.message, loading: false })
                    }).catch(error => {
                        this.setState({ responseString: error.message, loading: false })
                    });
                console.log("Deleting vendor successful");
            }).catch(error => {
                console.log("Deleting vendor failed with an exception");
                this.setState({ responseString: error.response.data.message, loading: false })
            });
    }

    handleChangeDriveDropdown(e) {
        this.setState({ loading: true });
        this.setState({ driveFinal: e.target.value });
        this.setState({ loading: false });
    }

    resetFields() {
        this.setState({ value: '' });
        this.setState({ driveFinal: '' });
        this.setState({ responseString: '' });
    }

    toggleEdit(editBool, index) {
        if (this.canEditField()) {
            let editable = this.state.isEditable;
            editable[index] = editBool;
            let readonlyArr = this.state.readOnly;
            readonlyArr[index] = '';
            this.setState({ isEditable: editable });
            this.setState({ readOnly: readonlyArr });
        } else {
            this.setState({ responseString: 'Can edit only one row at a time' });
        }

    }

    canEditField() {
        for (var i = 0; i < this.state.isEditable.length; i++) {
            if (!this.state.isEditable[i]) {
                return false;
            }
        }
        return true;
    }

    toggleSave(editBool, index, vendorname, vendorPath, drive, deployedApps) {
        let editable = this.state.isEditable;
        editable[index] = editBool;
        let readonlyArr = this.state.readOnly;
        readonlyArr[index] = 'readOnly';
        this.handleEditPathAndSaveinApps(vendorname, drive, vendorPath, deployedApps);
        this.setState({ isEditable: editable });
        this.setState({ readOnly: readonlyArr });
    }

    handleEditPathAndSaveinApps(vendorname, oldpath, newPath, deployedApps) {
        this.setState({ loading: true });
        var url = HostName + "/api/v1/editpath";
        axios.put(url, {
            "vendorname": vendorname,
            "oldPath": oldpath,
            "newPath": newPath,
            "deployedApps": deployedApps
        }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("accessToken")
                }, timeout: config.TimeOut
            }).then(resp => {
                var url = HostName + "/api/v1/copy";
                var vendorsList = this.state.vendors;

                for (var i = 0; i < vendorsList.length; i++) {
                    if (vendorname === vendorsList[i].name) {
                        var length = (vendorsList[i].deployedApps).length;
                        if (length > 0) {
                            for (var j = 0; j < length; j++) {
                                axios.put(url, {
                                    "vendorname": vendorname,
                                    "appType": vendorsList[i].deployedApps[j].appType,
                                    "appName": vendorsList[i].deployedApps[j].applicationName,
                                    "version": vendorsList[i].deployedApps[j].applicationVersion,
                                    "drive": newPath
                                }, {
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
                                        }, timeout: config.TimeOut
                                    }).then(resp => {
                                        this.setState({ responseString: resp.data.message });
                                        this.setState({ className: 'text-success' });
                                        this.setState({ loading: false });
                                    }).catch(error => {
                                        this.setState({ responseString: error.response.data.message });
                                        this.setState({ className: 'text-danger' });
                                        this.setState({ loading: false });
                                    });
                            }
                        } else {
                            this.setState({ loading: false });
                        }
                    }
                }

            }).catch(error => {
                this.setState({ loading: false });
                console.error("Editing vendor path failed with an exception", error);
                this.setState({ responseString: error.response.data.message })
            });
    }

    render() {
        if (this.state.isUserLoggedIn) {
            return (
                <div>
                    <form onSubmit={this.handleSubmit}>
                        <div id="addVendor">
                            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
                            <input type="text" className="form-control-md" id="vendor" value={this.state.value} onChange={this.handleChange} placeholder="Add a new Vendor.." required />
                            <input type="text" className="form-control-md" id="vendor" value={this.state.driveFinal} onChange={this.handleSharePath} placeholder="Network path.." required />
                            <b className="text-sm-left">(e.g: \\127.0.0.1\Share)</b><br /><br />
                            <button type="submit" className="btn btn-primary btn-sm" value="Add" onClick={(e) => this.handleSubmit}> Submit</button >&nbsp; &nbsp;&nbsp;
                            <button type="reset" className="btn btn-secondary btn-sm" value="Reset" onClick={this.resetFields}>Reset</button >
                        </div>
                    </form>
                    <div>
                        <p className={this.state.className}>{this.state.responseString}</p>
                    </div>
                    <h3 className="font-weight-bold text-center">Vendors List</h3>
                    <div id="listVendors">
                        <table className="table table-hover" id="tabledata">
                            <thead className='thead-dark'>
                                <tr>
                                    <th className='text-center'>Vendor Name</th>
                                    <th className='text-center'>Share path</th>
                                    <th className='text-center'>Edit path</th>
                                    <th className='text-center'>Delete vendor</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                {this.state.vendors.map(((vendors, index) => {
                                    return (
                                        <tr key={vendors.name}>
                                            <td><span className="deleteStyling text-primary font-weight-bold" onClick={JwModal.open('my-custom-modal1', vendors.name, vendors.AWS_ACCESS_KEY, vendors.AWS_SECRET_ID, vendors.drive, vendors.deployedApps)}>{vendors.name}</span></td>
                                            <td><input type="text" className="form-control" id={index} placeholder={this.state.tempDrive[index]} readOnly={this.state.readOnly[index]} onChange={this.changePath} /></td>
                                            <td>
                                                {this.state.isEditable[index] ?
                                                    <span className="glyphicon glyphicon-edit deleteStyling" onClick={e => this.toggleEdit(false, index)} ></span>
                                                    :
                                                    <span className="glyphicon glyphicon-save-file deleteStyling" onClick={e => this.toggleSave(true, index, vendors.name, this.state.tempDrive[index], vendors.drive, vendors.deployedApps)} ></span>
                                                }
                                            </td>
                                            <td><span className=" glyphicon glyphicon-trash text-danger deleteStyling" onClick={e => this.handleDelete(vendors.name, vendors.AWS_ACCESS_KEY)}></span></td>
                                        </tr>
                                    )
                                }))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        {
                            this.state.loading ? <LoadingSpinner /> : null
                        }
                    </div>
                    <div>
                        <JwModal id="my-custom-modal1">
                            <button className="btn btn-success" onClick={JwModal.close('my-custom-modal1')}>Done</button>
                        </JwModal>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div id="loader">
                    <p><font color="red">Session Invalid. Please Login to continue.</font></p>
                    <button type="button" className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={this.navigateToLogin.bind(this)} >Login</button>
                </div>
            );
        }
    }
}
export default VendorMgmt;


// WEBPACK FOOTER //
// ./src/VendorMgmt.js